var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloseFilled(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 2C6.477 2 2 6.477 2 12C2 17.523 6.477 22 12 22C17.523 22 22 17.523 22 12C22 6.477 17.523 2 12 2ZM15.961 14.547C16.352 14.938 16.352 15.57 15.961 15.961C15.766 16.156 15.51 16.254 15.254 16.254C14.998 16.254 14.742 16.156 14.547 15.961L12 13.414L9.441 15.973C9.246 16.168 8.99 16.266 8.734 16.266C8.478 16.266 8.222 16.168 8.027 15.973C7.636 15.582 7.636 14.95 8.027 14.559L10.586 12L8.05 9.464C7.659 9.073 7.659 8.441 8.05 8.05C8.441 7.659 9.073 7.659 9.464 8.05L12 10.586L14.513 8.073C14.904 7.682 15.536 7.682 15.927 8.073C16.318 8.464 16.318 9.096 15.927 9.487L13.414 12L15.961 14.547Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseFilled);
export default __webpack_public_path__ + "static/media/closeFilled.3cb7707fa155b786f184a04487846477.svg";
export { ForwardRef as ReactComponent };